<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi1"><a id="page_iii"></a><em class="italic">To-----------------------</em></p>
<p class="dedi"><em class="italic">Reckless raconteurs may lie valiantly, but their volumes frequently flatter</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?c9075732